/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInvoiceRequestCompany
 */
export interface GenerateInvoiceRequestCompany {
    /**
     * 
     * @type {string}
     * @memberof GenerateInvoiceRequestCompany
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateInvoiceRequestCompany
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateInvoiceRequestCompany
     */
    address: string;
}

/**
 * Check if a given object implements the GenerateInvoiceRequestCompany interface.
 */
export function instanceOfGenerateInvoiceRequestCompany(value: object): value is GenerateInvoiceRequestCompany {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function GenerateInvoiceRequestCompanyFromJSON(json: any): GenerateInvoiceRequestCompany {
    return GenerateInvoiceRequestCompanyFromJSONTyped(json, false);
}

export function GenerateInvoiceRequestCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInvoiceRequestCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'taxId': json['taxId'],
        'address': json['address'],
    };
}

export function GenerateInvoiceRequestCompanyToJSON(json: any): GenerateInvoiceRequestCompany {
    return GenerateInvoiceRequestCompanyToJSONTyped(json, false);
}

export function GenerateInvoiceRequestCompanyToJSONTyped(value?: GenerateInvoiceRequestCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'taxId': value['taxId'],
        'address': value['address'],
    };
}

